import { gql } from 'apollo-boost';

export const offlineReportListQuery = gql`
    query offlineReportList {
        reqId: getReqId
        offlineReportList {
            list {
                reportId
                uid
                args
                scheduledAt
                reportState
                reportType
                reportUrl
            }
        }
    }
`;

export const offlineReportCreateQuery = gql`
    query offlineReportCreate($input: GdOfflineReportResultRequestInput!) {
        reqId: getReqId
        offlineReportCreate(input: $input) {
            reportId
            uid
            args
            scheduledAt
            reportState
            reportType
        }
    }
`;
